import { getUrl, Request } from '../../request';

export const postTokenLogin = (token) =>
  Request.post(getUrl('/api/v1/accounts/token-login/'), {
    token
  });

export const getCaptcha = (font_color, color, base_color) =>
  Request.get(getUrl('/api/v1/accounts/captcha/'), {
    font_color,
    color,
    base_color
  });

export const postSendOtp = (phone_number, city_id, captcha_uuid, captcha) =>
  Request.post(getUrl('/api/v1/accounts/login/'), {
    phone_number,
    city_id,
    captcha_uuid,
    captcha
  });

export const postCheckOtp = (phone_number, otp_code) =>
  Request.post(getUrl('/api/v1/accounts/login/'), {
    phone_number,
    otp_code
  });

export const getUserAddresses = (city_id) =>
  Request.get(getUrl('/api/v1/accounts/user-addresses/'), {
    city_id
  });

export const postUserAddresses = (region_id, address, latitude, longitude, zip_code) =>
  Request.post(getUrl('/api/v1/accounts/user-addresses/'), {
    region_id,
    address,
    latitude,
    longitude,
    zip_code
  });

export const deleteUserAddresses = (address_to_delete) =>
  Request.del(getUrl(`/api/v1/accounts/user-addresses/${address_to_delete}/`));

export const putUserAddresses = (region_id, address, latitude, longitude, zip_code, address_id) =>
  Request.put(getUrl(`/api/v1/accounts/user-addresses/${address_id}/`), {
    region_id,
    address,
    latitude,
    longitude,
    zip_code
  });

export const editProfile = () => Request.get(getUrl('/api/v1/accounts/user/'));

export const checkOtpPage = () => Request.get(getUrl('/api/v1/accounts/show-otp/'));

export const getCredits = (type, price_from, price_to, date_from, date_to, sort_value, page) => {
  const sort_keys = [
    { id: 1, value: '-created_at' },
    { id: 2, value: 'amount' },
    { id: 3, value: '-amount' }
  ];

  const type_keys = [
    { id: 1, value: 'all' },
    { id: 2, value: 'increase' },
    { id: 3, value: 'decrease' }
  ];

  const query = {
    type: type_keys.find((type_item) => type_item.id === type)?.value || type_keys[0].value,
    min_price: price_from || null,
    max_price: price_to || null,
    start_date: date_from ? date_from.format('YYYY/M/D') : null,
    end_date: date_to ? date_to.format('YYYY/M/D') : null,
    sort: sort_keys.find((sort_item) => sort_item.id === sort_value)?.value || sort_keys[0].value,
    page
  };

  return Request.get(getUrl('/api/v1/accounts/credit/'), query);
};

export const getCreditSummery = () => Request.get(getUrl('/api/v1/accounts/credit-summary'));

export const postGiftCreditCode = (discount_code) =>
  Request.post(getUrl('/api/v1/accounts/credit/'), {
    discount_code
  });

export const putEditProfile = (
  phone_number,
  first_name,
  last_name,
  nid,
  credit_card,
  naghsh_code,
  ni_validation
) =>
  Request.put(getUrl('/api/v1/accounts/user/'), {
    phone_number,
    first_name,
    last_name,
    nid,
    credit_card,
    naghsh_code,
    ni_validation
  });
